import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./StaffEquipmentDetails.module.css";
import { Table } from "antd";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../components/TopTabComponent/TopTabComponent";
import { InputField, Modal, SubmitButton, TextComponent } from '../../../../components';




const tabOptions = [
  { id: 1, name: "Basic Info", },
  { id: 2, name: "Maintenance Log", },
];


const StaffEquipmentDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const MachineType = location.state?.MachineType || "Automatic ";
  const options = [
    { id: 1, name: "Program 1" },
    { id: 2, name: "Program 2" },
    { id: 3, name: "Program 3" },
  ];
  const [focusedTab, setFocusedTab] = useState(options[0]);
  const [focusedMainTab, setFocusedMainTab] = useState(tabOptions[0]);
  const [isModal, setIsModal] = useState(false);
  const [newLogModal, setNewLogModal] = useState(false)
  const [date, setDate] = useState("")
  const [byName, setByName] = useState("")
  const [notes, setNotes] = useState("")

  const [parameterData, setParameterData] = useState([
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
      value: "45",
    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
      value: "250",
    },
  ]);

  const columns = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
  ];

  const ManaualColumn = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
  ];

  const [ManualData, setManualData] = useState([
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
    },
  ]);


  const maintenanceColumns = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
    },
    {
      title: "By",
      dataIndex: "By",
      key: "By ",
    },
    {
      title: "Timestamp",
      key: "Timestamp",
      dataIndex: "Timestamp",
    },
    {
      title: "Notes",
      key: "Notes",
      dataIndex: "Notes",
    },
  ];

  const maintenanceData = [
    {
      Date: "2025-08-15",
      By: "John Smith ",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
    {
      Date: "2025-08-15",
      By: "Sarah Jones ",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
    {
      Date: "2025-08-15",
      By: "David Smith ",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
  ];

  return (
    <div>
      <HeaderComponent

        heading={"Stand Mixer"}
        onSearch={(e) => console.log(e.target.value)}
        submitButtonText={false}
        showBackIcon={true}

      >
        <TopTabComponent
          options={tabOptions}
          focused={focusedMainTab}
          setFocused={setFocusedMainTab}
        // TopTabListStyle={styles.TopTabListStyle1}
        />


      </HeaderComponent>
      {focusedMainTab?.name === tabOptions[0]?.name &&
        <div className={styles.mainDetCont}>
          {/* ///////////////////left side details/////////////// */}
          <div className={styles.leftSideCont}>
            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Station"}
              />
              <TextComponent
                fontFamily={"Inter-semiBold"}
                text={"Mixing, Oven, Proof / Chill"}
              />
            </div>

            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Machine Type"}
              />
              <TextComponent fontFamily={"Inter-semiBold"} text={MachineType === "Automatic" ? "Automatic" : "Manual"} />
            </div>

            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Recommended Operator"}
              />
              <TextComponent fontFamily={"Inter-semiBold"} text={"02"} />
            </div>

            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Skill Level"}
              />
              <TextComponent fontFamily={"Inter-semiBold"} text={"Expert"} />
            </div>
            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Category"}
              />
              <TextComponent fontFamily={"Inter-semiBold"} text={"Oven"} />
            </div>
            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Minimum Weight Capacity"}
              />
              <TextComponent fontFamily={"Inter-semiBold"} text={"200 lbs"} />
            </div>
            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Maximum Weight Capacity"}
              />
              <TextComponent fontFamily={"Inter-semiBold"} text={"250 lbs"} />
            </div>
            <div>
              <TextComponent
                fontFamily={"Inter-semiBold"}
                className={styles.leftProText}
                text={"Maintenance Due(Days)"}
              />
              <TextComponent fontFamily={"Inter-semiBold"} text={"3"} />
            </div>
          </div>

          {/* ///////////////////right side details/////////////// */}
          <div className={styles.rightSideCont}>
            <div className={styles.TableDiv}>
              {MachineType === "Automatic" ? (
                <>
                  <TopTabComponent
                    options={options}
                    focused={focusedTab}
                    setFocused={setFocusedTab}
                    TopTabListStyle={styles.TopTabListStyle1}
                  />
                  <Table
                    scroll={{ x: true }}
                    columns={columns}
                    dataSource={parameterData}
                    pagination={false}
                    rowKey="parameters"
                  />
                </>
              ) : (
                <Table
                  scroll={{ x: true }}
                  columns={ManaualColumn}
                  dataSource={ManualData}
                  pagination={false}
                  rowKey="parameters"
                />
              )}

              {/* {focusedTab == options[0] ? <Program /> : <Mixing />} */}
            </div>
          </div>
        </div>
      }

      {focusedMainTab?.name === tabOptions[1]?.name &&
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={maintenanceColumns}
            dataSource={maintenanceData}
            pagination={false}
            rowKey="no"
          />

        </div>
      }



    </div>
  );
};

export default StaffEquipmentDetails;
